import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {Route, BrowserRouter as Router, Routes} from "react-router-dom";
import {MsalProvider} from "@azure/msal-react";
import {PublicClientApplication} from "@azure/msal-browser";
import {store} from "store";
import {msalConfig} from "utils/msalConfig";
import {WrappedIntlProvider} from "utils/intl";
import App from "components/App";
import "./index.scss";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient();
ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <WrappedIntlProvider>
          <QueryClientProvider client={queryClient}>
            <Router basename={""}>
              <Routes>
                <Route path="/studio" element={<App />} />
              </Routes>
            </Router>
          </QueryClientProvider>
        </WrappedIntlProvider>
      </Provider>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);
